import { render, staticRenderFns } from "./Bets.vue?vue&type=template&id=d41efd7c&scoped=true"
import script from "./Bets.vue?vue&type=script&lang=js"
export * from "./Bets.vue?vue&type=script&lang=js"
import style0 from "./Bets.vue?vue&type=style&index=0&id=d41efd7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d41efd7c",
  null
  
)

export default component.exports